import script from "./ThreeDPartDetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDPartDetailsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDPartDetailsCard.vue?vue&type=style&index=0&id=1661486c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1661486c"]])

export default __exports__